var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-text-center"},[(_vm.message)?_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }